'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactRedux = require('react-redux');

var _Matcher = require('shared/modules/Matcher');

var _Contents = require('./Contents');

var _Contents2 = _interopRequireDefault(_Contents);

var _selectors = require('../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Element = _reactScroll2.default.Element;
//import ReactDOM from 'react-dom';

var CLASS_NAME = 'match-me';

var SCROLL_OPTIONS = {
  duration: 700,
  smooth: true
};

var matcher = void 0;

function MatchMe(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      buttonTitle = _ref.buttonTitle,
      buttonAltSubtext = _ref.buttonAltSubtext,
      buttonSubtext = _ref.buttonSubtext,
      image = _ref.image,
      imageAlt = _ref.imageAlt,
      icon = _ref.icon,
      iconAlt = _ref.iconAlt,
      visible = _ref.visible,
      matchMe = _ref.matchMe,
      jobLimit = _ref.jobLimit;

  var classNames = [CLASS_NAME, 'secondary', visible ? 'matcher-visible' : 'matcher-invisible'];

  if (!visible) {
    matcher = null;
  }

  var content = visible ? _react2.default.createElement(
    Element,
    {
      name: 'matcher'
    },
    _react2.default.createElement(_Matcher.Matcher, {
      handleClose: function handleClose() {
        return matchMe(false);
      },
      ref: function ref(c) {
        if (!matcher && c) {
          matcher = c;
          setTimeout(function () {
            _reactScroll2.default.scroller.scrollTo('matcher', SCROLL_OPTIONS);
          });
        }
      },
      jobLimit: jobLimit
    })
  ) : _react2.default.createElement(
    'a',
    {
      className: 'button-link secondary',
      onClick: function onClick() {
        matchMe(true);
        ga('send', 'event', 'Click', 'Match Toolbar Trigger', 'Homepage Call-out Button');
      }
    },
    _react2.default.createElement(
      'span',
      { className: 'desktop-only' },
      buttonSubtext
    ),
    _react2.default.createElement(
      'span',
      { className: 'mobile-only' },
      buttonAltSubtext
    )
  );

  return _react2.default.createElement(
    'article',
    { className: classNames.join(' ') },
    _react2.default.createElement(
      _Contents2.default,
      {
        title: title,
        subtext: subtext,
        buttonTitle: buttonTitle,
        icon: icon,
        iconAlt: iconAlt,
        image: image,
        imageAlt: imageAlt,
        jobLimit: jobLimit
      },
      content
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(MatchMe);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/MatchMe/components/MatchMe.jsx
// module id = 1092
// module chunks = 0